import {Theme} from '@lookiero/aurora';
import StyleSheet from 'react-native-extended-stylesheet';

const {space2, space4, space1, colorTextMediumLight, colorText, borderStyle} = Theme.get();

// TODO revisit this calc.
const indicatorSize = space4 + space1 + space1;

const checkedColor = colorText;
const defaultColor = colorTextMediumLight;

export const style = StyleSheet.create({
  step: {
    alignItems: 'flex-start',
    flexDirection: 'row',
    position: 'relative',
  },
  stepContent: {
    paddingLeft: space2 + space1,
    flexDirection: 'row',
    flexWrap: 'wrap',
    flex: 1,
    paddingVertical: space2 + space1,
  },
  stepText_disabled: {
    color: defaultColor,
  },
  track: {
    borderRightWidth: 1,
    borderStyle: borderStyle,
    borderColor: defaultColor,
    position: 'absolute',
    left: () => indicatorSize / 2,
    zIndex: -1,
  },
  trackTop: {
    top: 0,
    height: space2 + space1 + indicatorSize / 2,
  },
  trackBottom: {
    bottom: 0,
    height: '60%',
  },
  trackTop_checked: {
    borderColor: checkedColor,
  },
  trackBottom_checked: {
    borderColor: checkedColor,
  },
  trackTop_default: {
    borderColor: checkedColor,
  },
  trackBottom_default: {
    borderColor: defaultColor,
  },
  trackTop_disabled: {
    borderColor: defaultColor,
  },
  trackBottom_disabled: {
    borderColor: defaultColor,
  },
});
